const accountingProviders = {
  qbo: { id: 'qbo', name: 'QuickBooks' },
  xero: { id: 'xero', name: 'Xero' },
};

export default accountingProviders;
